import { render, staticRenderFns } from "./bottom-home.vue?vue&type=template&id=5155a4b2&scoped=true&"
import script from "./bottom-home.vue?vue&type=script&lang=js&"
export * from "./bottom-home.vue?vue&type=script&lang=js&"
import style0 from "./bottom-home.vue?vue&type=style&index=0&id=5155a4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5155a4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5155a4b2')) {
      api.createRecord('5155a4b2', component.options)
    } else {
      api.reload('5155a4b2', component.options)
    }
    module.hot.accept("./bottom-home.vue?vue&type=template&id=5155a4b2&scoped=true&", function () {
      api.rerender('5155a4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/home/components/bottom-home.vue"
export default component.exports